import { mesaColorNames, fontFamilies } from '@/src/common/theme'
import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  header: {
    padding: 0,
    marginBottom: 32,
  },
  headerTitle: {
    gap: 10,
    padding: 16,
    alignItems: 'center',
  },
  headerCaption: {
    color: mesaColorNames['Mesa - Brand/Blackish #222222'],
    fontSize: 14,
  },
  optionsContainer: {
    paddingHorizontal: 16,
  },
  subtitle: {
    fontFamily: fontFamilies['PlusJakartaSans-Regular'],
    fontWeight: 400,
    fontSize: 14,
    color: mesaColorNames['Greyscale/600 #505D64'],
  },
  subtitle_error: {
    color: mesaColorNames['Mesa Third #E78A43'],
  },
})
